<template>
  <div class="flex flex-col border-b border-grey-600 bg-white px-2 py-2.5">
    <button
      class="flex select-none items-center gap-x-2 text-grey-900"
      @click="toggleExpanded"
    >
      <ChevronDownIcon
        class="h-6 w-6 transition-transform duration-300 ease-in-out"
        :class="{ 'rotate-180': isExpanded }"
      />
      <span class="text-sm font-semibold">{{ title }}</span>
    </button>
    <div
      class="duration-300 ease-in-out"
      :class="isExpanded ? 'mt-3 max-h-[400px]' : 'max-h-0 overflow-hidden'"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import ChevronDownIcon from '~/assets/icons/ChevronDown.svg'

defineProps<{
  title: string
}>()

const isExpanded = ref(false)

const toggleExpanded = () => {
  isExpanded.value = !isExpanded.value
}
</script>
